"use strict";

var _jsxRuntime = require("react/jsx-runtime");
module.exports = ({
  title,
  titleId,
  size,
  color,
  ...props
}) => /*#__PURE__*/(0, _jsxRuntime.jsxs)("svg", {
  ...props,
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  height: size,
  width: size,
  fill: color,
  role: title ? 'img' : undefined,
  "aria-hidden": !title,
  "aria-labelledby": titleId,
  children: [title ? /*#__PURE__*/(0, _jsxRuntime.jsx)("title", {
    id: titleId,
    children: title
  }) : null, /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    d: "M5.5 1h-3A2.503 2.503 0 0 0 0 3.5v8C0 12.878 1.122 14 2.5 14h5a.5.5 0 0 0 .5-.5v-10C8 2.122 6.878 1 5.5 1ZM24 10.25a2.24 2.24 0 0 0-1.235-2 2.24 2.24 0 0 0-1.001-3.001c.228-.456.295-.981.18-1.502C21.72 2.735 20.768 2 19.679 2H10.5c-.339 0-.769.055-1.208.154a.499.499 0 0 0-.378.595c.058.265.086.51.086.751v10c0 .269-.075.528-.222.771a.498.498 0 0 0-.026.468L11 19.609v3.39c0 .152.069.295.187.391.032.026.774.61 1.813.61 1.157 0 3-1.831 3-4 0-1.368-.49-3.071-.795-4h6.176c1.346 0 2.491-.996 2.608-2.266a2.483 2.483 0 0 0-.639-1.909c.411-.414.65-.974.65-1.575Z"
  })]
});